/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_PoaInputs */

const en_price_poa = /** @type {(inputs: Price_PoaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`POA`)
};

const id_price_poa = /** @type {(inputs: Price_PoaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`POA`)
};

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const es_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const fr_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const de_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const ja_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const zh_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const ar_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const it_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const ru_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const pt_price_poa = en_price_poa;

/** @type {(inputs: Price_PoaInputs) => LocalizedString} */
const ko_price_poa = en_price_poa;

/**
* | output |
* | --- |
* | "POA" |
*
* @param {Price_PoaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const price_poa = /** @type {((inputs?: Price_PoaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_PoaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_poa(inputs)
	if (locale === "es") return es_price_poa(inputs)
	if (locale === "fr") return fr_price_poa(inputs)
	if (locale === "de") return de_price_poa(inputs)
	if (locale === "ja") return ja_price_poa(inputs)
	if (locale === "zh") return zh_price_poa(inputs)
	if (locale === "ar") return ar_price_poa(inputs)
	if (locale === "id") return id_price_poa(inputs)
	if (locale === "it") return it_price_poa(inputs)
	if (locale === "ru") return ru_price_poa(inputs)
	if (locale === "pt") return pt_price_poa(inputs)
	return ko_price_poa(inputs)
});